import { Component, OnInit } from '@angular/core';
import { ILecture, ILectureFeedback } from 'src/app/views/pages/lectures/lecture.interface';
import migration from '../../../assets/data/migration.json';
import mapping from '../../../assets/data/mapping.json';
import { CitiesService } from 'src/app/views/pages/lectures/cities/cities.service';
import { ICity } from 'src/app/views/pages/lectures/cities/city.interface';
import { CountriesService } from 'src/app/views/pages/lectures/cities/countries.service';
import { LectureValuesService } from 'src/app/submit-lecture/lecture-values/lecture-values.service';
import { FirestoreRulesService } from 'src/app/core/firestore-rules/firestore-rules.service';
import { AgeGroupEnum, LanguagesEnum, LectureOnlineTypeEnum,
         LecturePriorityEnum, LectureStatusEnum, LectureTypeEnum, LectureValuesData } from 'src/app/submit-lecture/lecture.values';
import { LecturesService } from 'src/app/views/pages/lectures/lectures.service';

const USERS_LAST_USER_CHANGED_UPDATE_DATE = 'USERS_LAST_USER_CHANGED_UPDATE_DATE';

@Component({
  selector: 'migrate-lectures',
  templateUrl: './migrate-lectures.component.html',
  styleUrls: ['./migrate-lectures.component.scss']
})

export class MigrateLecturesComponent implements OnInit {

  migratingArr: ILecture[];
  lecturesTransformArr: ILecture[];
  failedLecturesTransformArr: ILecture[];
  lecturesMigrationArr: ILecture[];
  failedLecturesMigrationArr: ILecture[];
  users: any;
  defaultUserEmail: string;
  defaultUser: any;
  defaultCity: string;
  isFinished: boolean;

  constructor(private citiesService: CitiesService,
              private countriesService: CountriesService,
              private lectureValuesService: LectureValuesService,
              private firestoreService: FirestoreRulesService,
              private lecturesService: LecturesService) {
    this.defaultUserEmail = 'education.lectures@spaceil.com';
    // this.defaultUserEmail = 'betty.litman@spaceil.com';
    this.defaultCity = 'תל אביב - יפו';
    this.migratingArr = migration;
    this.lecturesTransformArr = [];
    this.failedLecturesTransformArr = [];
    this.lecturesMigrationArr = [];
    this.failedLecturesMigrationArr = [];
  }

  ngOnInit(): void {
    this.lecturesTransformArr = [];
    this.getAllUsers().then((res) => {
      this.users = res;
      this.defaultUser = this.getUserByEmail(this.defaultUserEmail);
      // this.normalizeAllNames();
      this.buildMigrationArry();
    });
  }


  start(): void {
    this.isFinished = false;
    this.addLectures();
    console.log(this.lecturesTransformArr);
  }

  private buildMigrationArry(): void {
    migration.forEach(lect => {

      const lecture: ILecture = {
        institute_name: lect.institute_name.replaceAll('\"', '"').replaceAll('\\', ''),
        age_group: null,
        contact_email: lect.contact_email.replace(/[\u0000-\u001F\u007F-\u009F]/g, ''),
        contact_name: lect.contact_name,
        contact_title: lect.contact_title,
        contact_phone: lect.contact_phone,
        class: lect.class,
        language: LanguagesEnum.HEBREW,
        online_type: null,
        notes: '',
        type: null,
        priority: LecturePriorityEnum.NORMAL,
        created_at: lect.created_at,
        updated_at: lect.updated_at,
        status: LectureStatusEnum.PENDING,
        address: {
          street: '',
          country: lect.address.country,
          city: lect.address.city
        }
      };
      try {
        const emailParts = lect.contact_email.split(',');
        lecture.contact_email = emailParts[1]?.trim() ?? '';

        const phoneParts = lect.contact_phone.split(',');
        lecture.contact_phone = phoneParts[1]?.trim() ?? '';

        lecture.contact_name = lect.contact_name.trim() ?? '';

        let city: ICity = this.citiesService.getCityInfo(lect.address.city);
        if (!city) {
          // Set Default
          city = this.citiesService.getCityInfo(this.defaultCity);
        }
        lecture.address.city = city.id;
        lecture.address.district = Number(city.district_id);
        lecture.address.subdistrict = Number(city.subdistrict_id);
        if (!lect.address.country || lect.address.country === '') {
          lecture.address.country = this.countriesService.getDefaultCountry().id;
        }
        if (!lect.address.house_number || lect.address.house_number === '') {
          lecture.address.house_number = 0;
        } else {
          lecture.address.house_number = Number(lect.address.house_number);
        }
        let age = this.lectureValuesService.getAgeGroupInfo(lect.age_group, true);
        if (!age) {
          age = this.lectureValuesService.getAgeGroupInfo(AgeGroupEnum.ADULTS);
          const adultsType = this.lectureValuesService.getAdultsInstituteType(lect.age_group);
          if (adultsType) {
            lecture.adultInstituteType = adultsType.id;
          }
        }
        lecture.age_group = age.id;
        if (lect.created_at) {
          const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
          const dt = new Date(lect.created_at.replace(pattern, '$3-$2-$1'));
          lecture.created_at = new Date(dt);
        } else {
          lecture.created_at = new Date();
        }

        lecture.status = this.getStatus(lect.status);
        if (!lecture.status) {
          // Check for paid
          const isPaid = (lect.status === LectureValuesData.PAID_STATUS.nameEN) || (lect.status === LectureValuesData.PAID_STATUS.nameHE);
          if (isPaid) {
            lecture.status = LectureStatusEnum.UNASSIGNED;
            lecture.type = LectureTypeEnum.PAID;
          } else {
            lecture.type = LectureTypeEnum.NONPAID;
          }
        } else {
          lecture.type = LectureTypeEnum.NONPAID;
        }

        const origName = lect.assigned_name;
        let assignedUser = null;
        if (lect.assigned_email && lect.assigned_email.length > 0) {
          assignedUser = this.getUserByEmail(lect.assigned_email);
          // if (!assignedUser && lecture.status !== LectureStatusEnum.UNASSIGNED) {
          //   assignedUser = this.getUserByEmail(this.defaultUser);
          // }
        } else {
          assignedUser = this.defaultUser;
        }

        if (assignedUser) {
          lecture.assigned_name = assignedUser.firstName.trim() + ' ' + assignedUser.lastName.trim();
          lecture.assigned_uid = assignedUser.metadata.docId;
        }

        if (lect.feedback) {
          const fb = {} as ILectureFeedback;
          fb.numberOfAttendees = isNaN(lect.feedback.numberOfAttendees) ? 0 : Number(lect.feedback.numberOfAttendees);
          fb.numberOfLectures = isNaN(lect.feedback.numberOfLectures) ? 0 : Number(lect.feedback.numberOfLectures);
          fb.feedback = lect.notesextra.includes('??') ? '' : lect.notesextra;
          lecture.feedback = fb;
        }

        // if (lect.notes) {
        //   const placeholders = ['הערות', 'ימים אפשריים לקיום ההרצאה', 'חוברת', 'שפה מועדפת'];
        //   const vals = {};
        //   for (let i = 0 ; i < placeholders.length; i++) {
        //     if (lect.notes.indexOf(placeholders[i]) < 0 ) {
        //       continue;
        //     }
        //     let str;
        //     if (i < placeholders.length - 1) {
        //       const str1 = lect.notes.split(placeholders[i]);
        //       const str2 = str1[1].split(new RegExp(placeholders.join('|'), 'g'));
        //       str = str2[0].substring(1);
        //     } else {
        //       const str1 = lect.notes.split(placeholders[i]);
        //       str = str1[1].substring(1);
        //     }
        //     vals[placeholders[i]] = str;
        //   }

        //   // tslint:disable-next-line:no-string-literal
        //   lecture.notes = vals['הערות']?.replaceAll('??', '') ?? '';
        //   if (lect.notesextra) {
        //     const notesExtraPH = LectureValuesData.NOTES_EXTRA_PH.nameHE;
        //     lecture.notes += '; ' + notesExtraPH + ': ' + lect.notesextra;
        //   }
        //   const language = this.getLanguage(vals['שפה מועדפת']);
        //   if (language) {
        //     lecture.language = language;
        //   }

        //   const weekdays = vals['ימים אפשריים לקיום ההרצאה'];
        //   const daysArr = [];
        //   if (weekdays) {
        //     const days = LectureValuesData.weekdays;
        //     days.forEach(day => {
        //       if (weekdays.indexOf(day.nameHE) >= 0) {
        //         daysArr.push(day.id);
        //       }
        //     });
        //   }
        //   if (daysArr.length > 0) {
        //     lecture.weekdays = daysArr;
        //   }
        // }

        if (lect.notes?.length > 0) {
          const vals = lect.notes.split('??');
          lecture.notes = vals[2] ? vals[2] : ( vals[3] ? vals[3] : '');
        }

        lecture.notes = lecture.notes ?? '';

        // const origLecturer = this.getOrigLecturer(lect.skyz_id);
        const origLecturer = origName;
        if (origLecturer) {
          if (lecture.notes?.length === 0) {
            lecture.notes = LectureValuesData.ORIG_LECTURER.nameHE + ': ' + origLecturer;
          } else {
            lecture.notes += '; ' + LectureValuesData.ORIG_LECTURER.nameHE + ': ' + origLecturer;
          }
        }

        if (lecture.status !== LectureStatusEnum.UNASSIGNED) {
          if (lect.scheduled_date) {
            const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            const dt = new Date(lect.scheduled_date.replace(pattern, '$3-$2-$1'));
            lecture.scheduled_date = new Date(dt);
          } else {
            lecture.scheduled_date = new Date();
          }
          lecture.assigned_at = lecture.scheduled_date;
        }

        lecture.online_type = LectureOnlineTypeEnum.FRONTAL;
        lecture.skyz_id = lect.skyz_id;
        lecture.updated_at = new Date();
        this.lecturesTransformArr.push(lecture);
      } catch (err) {
        console.error('Failed migrating lecture ', lect);
        console.error(err);
        this.failedLecturesTransformArr.push(lect);
      }
    });
    console.log(this.lecturesTransformArr);
  }

  private addLectures(): void{
    this.lecturesTransformArr.forEach(async lecture => {

      // check for existing lecture by skyzid
      const skyzId = lecture.skyz_id;
      if (skyzId) {
        const docs = await this.lecturesService.getLecturesBySkyzID(skyzId) as ILecture[];
        if (!docs || docs.length === 0) {
          this.lecturesService.addLecture(lecture, true)
          .then(() => {
            this.lecturesMigrationArr.push(lecture);
            console.log('Lecture added ', lecture);
          })
          .catch((error) => {
            this.failedLecturesMigrationArr.push(lecture);
            console.error('Lecture failed to be added ', lecture);
            console.error(error);
          });
        } else {
          if (docs.length > 0) {
            docs.forEach((lect, i) => {
              if (i > 0) {
                this.lecturesService.deleteLecture(lect.metadata?.docId);
              } else {
                lecture.metadata = {docId: lect.metadata.docId};
                this.lecturesService.updateLecture(lecture)
                .then(() => {
                  this.lecturesMigrationArr.push(lecture);
                  console.log('Lecture updated ', lecture);
                })
                .catch((error) => {
                  this.failedLecturesMigrationArr.push(lecture);
                  console.error('Lecture failed to update ', lecture);
                  console.error(error);
                });
              }
            });
          }
        }
      }
    });
    this.isFinished = true;
  }

  private getStatus(status: string): LectureStatusEnum {
    const filtered: any[] = LectureValuesData.statuses.filter(st => {
      return (status.includes(st.nameEN) || status.includes(st.nameHE));
    });
    return filtered[0]?.id;
  }

  private getLanguage(lang: string): LanguagesEnum {
    const filtered: any[] = LectureValuesData.languages.filter(st => {
      return (lang?.includes(st.nameEN) || lang?.includes(st.nameHE));
    });
    return filtered[0]?.id ?? LanguagesEnum.HEBREW;
  }

  private getAllUsers(): Promise<unknown> {
    let lastChangedDocs;

    return new Promise<unknown>(async (resolve, reject) => {
      try {
        const lastUserUpdateDate = localStorage.getItem(USERS_LAST_USER_CHANGED_UPDATE_DATE);
        let docs = await this.firestoreService.getAssignedUsers(true);
        // check if any lecture was updated since last cached
        if (docs && docs.length) {
          lastChangedDocs = await this.firestoreService.getLastChangedUser();
        }
        // if data was not fetched from cache or changes exist on fb lectures data then get data from fb
        if (!docs || docs.length === 0 || !lastUserUpdateDate || (lastChangedDocs && lastChangedDocs.length
            && this.checkIfLastLectureUpdateIsGreaterThenLocalDate(lastChangedDocs, lastUserUpdateDate))) {
          docs = await this.firestoreService.getAssignedUsers(false);
          if (lastChangedDocs) {
            localStorage.setItem(USERS_LAST_USER_CHANGED_UPDATE_DATE,
                this.convertToDate(lastChangedDocs[0]?.updated_at).toString());
          }
        }
        resolve(docs);
      } catch (error) {
        reject(error);
      }
    });
  }

  private getUserByEmail(email: string): any {
    const filtered: any[] = this.users.filter(user => {
      return (user.email?.includes(email));
    });

    return filtered[0] ?? this.defaultUser;
  }

  private normalizeAllNames(): any[] {
    return this.users.filter((user: any) => {
      user.normName = this.normalize(user.firstName + user.lastName);
      return user;
    });
  }

  private normalize(str: string): string {
    if (!str || str.length === 0) {
      return str;
    }
    let norm = str.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').toLowerCase();
    norm = norm.replace(/\s/g, '');
    return norm.replace(/מתנדב/g, '');

  }

  private checkIfLastLectureUpdateIsGreaterThenLocalDate(lastChangedDocs: any[], lastUserUpdateDate: string): boolean {
    const parsedDate = new Date(lastUserUpdateDate);
    const lastChangedDocDate = this.convertToDate(lastChangedDocs[0].updated_at);
    return (lastChangedDocDate > parsedDate);
  }

  private convertToDate(d: any): Date {
    if (!d) {
      return;
    }
    if (d instanceof Date) {
      return d;
    }

    const seconds = (d as any).seconds;
    const date = new Date(seconds * 1000);
    return date;
  }

  private getOrigLecturer(skyzId: string): string {
    const filtered = mapping.filter(m => {
      return m.Id === Number(skyzId);
    });
    return filtered[0]?.notes ?? '';
  }
}
